export * from './src/restaurants-ordersettings-v3-order-settings-order-settings.meta.js';
